import { render, staticRenderFns } from "./TimingHallRestaurant.vue?vue&type=template&id=adf853c0&"
import script from "./TimingHallRestaurant.vue?vue&type=script&lang=js&"
export * from "./TimingHallRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./TimingHallRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports